/**
 * Asynchronously loads the component
 */
import Loadable from 'react-loadable';

import SpinnerContainer from '../../components/SpinnerContainer';

export default Loadable({
  loader: () => import(/* webpackChunkName: "EmailVerificationPage.loadable" */ './index'),
  loading: SpinnerContainer,
});
